import React from 'react'
import Table from './Table'

export default function Tables (props) {
  return (
    <div className='mtt-ttmzero-greeks-risk__tables'>
      {props.tables.length > 0 && props.tables.map((section, i) => {
        return <Table {...section} key={i} />
      })}
    </div>
  )
}
